import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FLNavigationModule } from 'ng-flamelink';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ButtonComponent } from './button/button.component';
import { NavbarComponent } from './navbar/navbar.component';
import { LayoutComponent } from './layout/layout.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FLNavigationModule,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    ButtonComponent,
    NavbarComponent,
    LayoutComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ButtonComponent,
    NavbarComponent,
    LayoutComponent
  ],
})
export class UiModule {}
